import React from "react";
let asaya_sade = (
    <g>
        <g>
            <defs>
                <path id="SVGID_1_" d="M172.219,24.262l-3.955-2.988l-2.154,2.726c-1.494-1.012-3.252-1.231-4.965-1.231
			c-6.064,0-10.986,4.219-10.986,10.986c0,6.767,4.219,10.897,10.986,10.897c2.68,0,5.492,1.362,5.492,4.352
			c0,2.987-2.416,4.658-5.492,4.658s-5.668-1.846-5.668-4.658h-5.318c0,5.844,4.701,9.668,10.986,9.668
			c6.283,0,10.855-3.692,10.855-9.668c0-2.77-0.881-5.361-4.482-7.163c3.559-1.626,4.568-5.406,4.568-8.086
			c0-2.373-0.615-4.526-2.285-6.416L172.219,24.262z M166.77,33.754c0,3.735-2.549,6.021-5.625,6.021
			c-3.121,0-5.668-2.242-5.668-6.021c0-3.779,2.547-6.109,5.668-6.109C164.221,27.645,166.77,30.02,166.77,33.754z"/>
            </defs>
            <clipPath id="SVGID_2_">
                <use xlinkHref="#SVGID_1_"  overflow="visible"/>
            </clipPath>
            <g clipPath="url(#SVGID_2_)">
                <defs>
                    <rect id="SVGID_3_" x="3.541" y="5.475" width="213" height="55"/>
                </defs>
                <clipPath id="SVGID_4_">
                    <use xlinkHref="#SVGID_3_"  overflow="visible"/>
                </clipPath>
                <rect x="145.159" y="16.273" clipPath="url(#SVGID_4_)" fill="#004FD1" width="32.061" height="47.397"/>
            </g>
        </g>
        <g>
            <defs>
                <polygon id="SVGID_5_" points="23.316,14.33 23.316,33.446 8.243,14.374 3.541,14.374 3.541,45.136 9.341,45.136 9.341,24.394
			25.513,45.18 25.513,45.136 29.116,45.136 29.116,14.33 		"/>
            </defs>
            <clipPath id="SVGID_6_">
                <use xlinkHref="#SVGID_5_"  overflow="visible"/>
            </clipPath>
            <g clipPath="url(#SVGID_6_)">
                <defs>
                    <rect id="SVGID_7_" x="3.541" y="5.475" width="213" height="55"/>
                </defs>
                <clipPath id="SVGID_8_">
                    <use xlinkHref="#SVGID_7_"  overflow="visible"/>
                </clipPath>
                <rect x="-1.459" y="9.33" clipPath="url(#SVGID_8_)" fill="#004FD1" width="35.575" height="40.85"/>
            </g>
        </g>
        <g>
            <defs>
                <path id="SVGID_9_" d="M55.066,34.325c0-6.195-4.439-11.294-11.337-11.294c-6.9,0-11.207,5.099-11.207,11.294
			c0,6.241,4.219,11.293,11.25,11.293C50.803,45.618,55.066,40.566,55.066,34.325 M49.661,34.325c0,3.296-1.977,6.373-5.889,6.373
			c-3.911,0-5.888-3.077-5.888-6.373c0-3.252,2.021-6.416,5.888-6.416C47.375,27.909,49.661,31.073,49.661,34.325"/>
            </defs>
            <clipPath id="SVGID_10_">
                <use xlinkHref="#SVGID_9_"  overflow="visible"/>
            </clipPath>
            <g clipPath="url(#SVGID_10_)">
                <defs>
                    <rect id="SVGID_11_" x="3.541" y="5.475" width="213" height="55"/>
                </defs>
                <clipPath id="SVGID_12_">
                    <use xlinkHref="#SVGID_11_"  overflow="visible"/>
                </clipPath>
                <rect x="27.522" y="18.031" clipPath="url(#SVGID_12_)" fill="#004FD1" width="32.543" height="32.587"/>
            </g>
        </g>
        <g>
            <defs>
                <path id="SVGID_13_" d="M106.063,45.135V23.471h-5.142l-0.175,2.988c-1.231-2.153-4-3.515-6.899-3.515
			c-6.329-0.045-11.294,3.865-11.294,11.337c0,7.603,4.747,11.557,11.162,11.514c2.417-0.044,5.801-1.274,7.032-3.824l0.263,3.164
			H106.063z M94.33,40.873c-3.56,0-6.415-2.462-6.415-6.592c0-4.131,2.855-6.547,6.415-6.547
			C102.768,27.734,102.768,40.873,94.33,40.873z"/>
            </defs>
            <clipPath id="SVGID_14_">
                <use xlinkHref="#SVGID_13_"  overflow="visible"/>
            </clipPath>
            <g clipPath="url(#SVGID_14_)">
                <defs>
                    <rect id="SVGID_15_" x="3.541" y="5.475" width="213" height="55"/>
                </defs>
                <clipPath id="SVGID_16_">
                    <use xlinkHref="#SVGID_15_"  overflow="visible"/>
                </clipPath>
                <rect x="77.553" y="17.944" clipPath="url(#SVGID_16_)" fill="#004FD1" width="33.511" height="32.851"/>
            </g>
        </g>
        <g>
            <defs>
                <path id="SVGID_17_" d="M135.461,19.428c-2.328-4.745-7.293-6.109-12.084-6.109c-5.67,0.044-11.91,2.638-11.91,8.965
			c0,6.9,5.801,8.57,12.086,9.317c4.086,0.438,7.119,1.626,7.119,4.526c0,3.34-3.428,4.614-7.076,4.614
			c-3.734,0-7.293-1.494-8.656-4.879l-4.833,2.506c2.285,5.624,7.119,7.558,13.402,7.558c6.855,0,12.92-2.944,12.92-9.799
			c0-7.339-5.977-9.008-12.391-9.8c-3.691-0.439-6.857-1.187-6.857-3.867c0-2.284,2.066-4.087,6.373-4.087
			c3.34,0,6.24,1.671,7.295,3.428L135.461,19.428z"/>
            </defs>
            <clipPath id="SVGID_18_">
                <use xlinkHref="#SVGID_17_"  overflow="visible"/>
            </clipPath>
            <g clipPath="url(#SVGID_18_)">
                <defs>
                    <rect id="SVGID_19_" x="3.541" y="5.475" width="213" height="55"/>
                </defs>
                <clipPath id="SVGID_20_">
                    <use xlinkHref="#SVGID_19_"  overflow="visible"/>
                </clipPath>
                <rect x="105.106" y="8.318" clipPath="url(#SVGID_20_)" fill="#004FD1" width="36.322" height="42.607"/>
            </g>
        </g>
        <g>
            <defs>
                <path id="SVGID_21_" d="M176.485,14.374v30.761h5.361V34.062c0-3.253,2.199-5.933,5.361-5.933c2.857,0,4.924,1.67,4.924,5.625
			v11.381h5.359V33.709c0-6.371-2.725-10.546-8.877-10.546c-2.459,0-4.834,0.747-6.768,3.252V14.374H176.485z"/>
            </defs>
            <clipPath id="SVGID_22_">
                <use xlinkHref="#SVGID_21_"  overflow="visible"/>
            </clipPath>
            <g clipPath="url(#SVGID_22_)">
                <defs>
                    <rect id="SVGID_23_" x="3.541" y="5.475" width="213" height="55"/>
                </defs>
                <clipPath id="SVGID_24_">
                    <use xlinkHref="#SVGID_23_"  overflow="visible"/>
                </clipPath>
                <rect x="171.485" y="9.374" clipPath="url(#SVGID_24_)" fill="#004FD1" width="31.006" height="40.761"/>
            </g>
        </g>
        <g>
            <defs>
                <path id="SVGID_25_" d="M204.055,17.934v5.58h-4.043v4.615h4.043v9.36c0,5.404,3.076,8.086,7.777,7.909
			c1.627-0.044,2.902-0.308,4.439-0.923l-1.494-4.569c-0.791,0.396-1.758,0.658-2.594,0.658c-1.668,0-2.812-1.01-2.812-3.075v-9.36
			h6.021v-4.615h-5.977v-6.15L204.055,17.934z"/>
            </defs>
            <clipPath id="SVGID_26_">
                <use xlinkHref="#SVGID_25_"  overflow="visible"/>
            </clipPath>
            <g clipPath="url(#SVGID_26_)">
                <defs>
                    <rect id="SVGID_27_" x="3.541" y="5.475" width="213" height="55"/>
                </defs>
                <clipPath id="SVGID_28_">
                    <use xlinkHref="#SVGID_27_"  overflow="visible"/>
                </clipPath>
                <rect x="195.012" y="12.363" clipPath="url(#SVGID_28_)" fill="#004FD1" width="26.26" height="38.044"/>
            </g>
        </g>
        <g>
            <defs>
                <path id="SVGID_29_" d="M65.527,22.553c0,4.175,6.328,4.175,6.328,0S65.527,18.378,65.527,22.553"/>
            </defs>
            <clipPath id="SVGID_30_">
                <use xlinkHref="#SVGID_29_"  overflow="visible"/>
            </clipPath>
            <g clipPath="url(#SVGID_30_)">
                <defs>
                    <rect id="SVGID_31_" x="3.541" y="5.475" width="213" height="55"/>
                </defs>
                <clipPath id="SVGID_32_">
                    <use xlinkHref="#SVGID_31_"  overflow="visible"/>
                </clipPath>
                <rect x="60.527" y="14.421" clipPath="url(#SVGID_32_)" fill="#9650E6" width="16.328" height="16.263"/>
            </g>
        </g>
        <g>
            <defs>
                <polygon id="SVGID_33_" points="62.366,23.271 55.804,23.271 66.013,44.997 70.725,44.997 71.413,43.507 		"/>
            </defs>
            <clipPath id="SVGID_34_">
                <use xlinkHref="#SVGID_33_"  overflow="visible"/>
            </clipPath>
            <g clipPath="url(#SVGID_34_)">
                <defs>
                    <rect id="SVGID_35_" x="3.541" y="5.475" width="213" height="55"/>
                </defs>
                <clipPath id="SVGID_36_">
                    <use xlinkHref="#SVGID_35_"  overflow="visible"/>
                </clipPath>
                <rect x="50.804" y="18.271" clipPath="url(#SVGID_36_)" fill="#004FD1" width="25.608" height="31.726"/>
            </g>
        </g>
        <g>
            <defs>
                <path id="SVGID_37_" d="M143.299,19.421c-1.521,0-3.162,0.979-3.162,3.132c0,2.151,1.641,3.132,3.162,3.132
			c1.523,0,3.166-0.98,3.166-3.132C146.465,20.4,144.823,19.421,143.299,19.421"/>
            </defs>
            <clipPath id="SVGID_38_">
                <use xlinkHref="#SVGID_37_"  overflow="visible"/>
            </clipPath>
            <g clipPath="url(#SVGID_38_)">
                <defs>
                    <rect id="SVGID_39_" x="3.541" y="5.475" width="213" height="55"/>
                </defs>
                <clipPath id="SVGID_40_">
                    <use xlinkHref="#SVGID_39_"  overflow="visible"/>
                </clipPath>
                <rect x="135.137" y="14.421" clipPath="url(#SVGID_40_)" fill="#9650E6" width="16.328" height="16.264"/>
            </g>
        </g>
        <g>
            <defs>
                <path id="SVGID_41_" d="M143.301,28.126c-0.914,0-1.77-0.227-2.654-0.658v17.934h5.309V27.469
			C145.069,27.899,144.215,28.126,143.301,28.126"/>
            </defs>
            <clipPath id="SVGID_42_">
                <use xlinkHref="#SVGID_41_"  overflow="visible"/>
            </clipPath>
            <g clipPath="url(#SVGID_42_)">
                <defs>
                    <rect id="SVGID_43_" x="3.541" y="5.475" width="213" height="55"/>
                </defs>
                <clipPath id="SVGID_44_">
                    <use xlinkHref="#SVGID_43_"  overflow="visible"/>
                </clipPath>
                <rect x="135.647" y="22.468" clipPath="url(#SVGID_44_)" fill="#004FD1" width="15.309" height="27.934"/>
            </g>
        </g>
        <g>
            <defs>
                <path id="SVGID_45_" d="M66.019,44.997h6.003c0,0,7.339-30.664,33.544-39.51C105.567,5.487,75.935,5.93,66.019,44.997"/>
            </defs>
            <clipPath id="SVGID_46_">
                <use xlinkHref="#SVGID_45_"  overflow="visible"/>
            </clipPath>
            <g clipPath="url(#SVGID_46_)">
                <defs>
                    <rect id="SVGID_47_" x="3.541" y="5.475" width="213" height="55"/>
                </defs>
                <clipPath id="SVGID_48_">
                    <use xlinkHref="#SVGID_47_"  overflow="visible"/>
                </clipPath>
                <rect x="61.019" y="0.487" clipPath="url(#SVGID_48_)" fill="#005f7f" width="49.547" height="49.51"/>
            </g>
        </g>
    </g>
);

let eye_swift_white = (
    <g>
        <path fill="#33E800" d="M38.53,19.8c0,4.481,6.792,4.481,6.792,0C45.322,15.32,38.531,15.32,38.53,19.8 M158.607,16.44
		c-1.635,0-3.396,1.052-3.396,3.36c0,2.31,1.762,3.362,3.396,3.362s3.396-1.052,3.396-3.362
		C162.003,17.492,160.242,16.44,158.607,16.44"/>
        <path fill="#FFFFFF" d="M158.607,25.782c-0.98,0-1.899-0.243-2.85-0.706v19.246h5.697V25.077
		C160.505,25.54,159.589,25.782,158.607,25.782 M0.617,10.961v33.223h24.87v-6.168H6.835v-7.5h17.989v-5.838H6.833v-7.642h18.655
		v-6.075H0.617z"/>
        <path fill="#FFFFFF" d="M68.665,20.074c-7.594,0-12.435,5.126-12.435,12.244c0,7.5,4.794,12.483,12.862,12.483
		c3.56,0,7.594-1.233,10.062-3.797l-3.702-3.655c-1.329,1.377-4.129,2.185-6.265,2.185c-4.082,0-6.597-2.089-6.977-4.984h18.273
		C81.385,24.915,76.496,20.074,68.665,20.074 M74.93,29.756H62.305c0.854-3.037,3.417-4.556,6.55-4.556
		C72.177,25.2,74.55,26.72,74.93,29.756 M111.137,16.42c-2.517-5.126-7.88-6.597-13.053-6.597
		c-6.123,0.047-12.862,2.847-12.862,9.682c0,7.452,6.265,9.255,13.052,10.062c4.414,0.476,7.689,1.757,7.689,4.89
		c0,3.606-3.702,4.983-7.642,4.983c-4.034,0-7.879-1.613-9.35-5.269l-5.221,2.705c2.468,6.075,7.689,8.164,14.476,8.164
		c7.404,0,13.954-3.181,13.954-10.584c0-7.927-6.455-9.73-13.384-10.584c-3.987-0.475-7.404-1.282-7.404-4.177
		c0-2.468,2.23-4.414,6.882-4.414c3.607,0,6.739,1.803,7.878,3.702L111.137,16.42z"/>
        <path fill="#FFFFFF" d="M130.09,20.739l-5.078,17.608l-5.363-17.61h-6.455l8.209,23.542h6.74l2.422-6.931l2.088-7.83l2.089,7.83
		l2.42,6.931h6.739l8.164-23.541h-6.406l-5.364,17.608l-5.126-17.61L130.09,20.739z"/>
        <path fill="#FFFFFF" d="M176.259,44.186V26.197h6.882v-5.079h-6.882v-1.566c0-2.848,1.519-4.177,3.513-4.177
		c1.187,0,2.326,0.427,3.56,1.234l2.136-4.319c-1.9-1.234-4.035-1.898-6.074-1.898c-4.701,0-8.924,2.895-8.924,9.16v1.566h-4.367
		v5.08h4.367v17.987H176.259L176.259,44.186z M191.375,15.09v6.027h-4.367V26.1h4.367v10.11c0,5.838,3.322,8.733,8.4,8.543
		c1.757-0.047,3.133-0.332,4.795-0.997l-1.614-4.936c-0.854,0.427-1.899,0.712-2.8,0.712c-1.805,0-3.038-1.091-3.038-3.322V26.1
		h6.502v-4.983h-6.455v-6.645L191.375,15.09L191.375,15.09z"/>
        <path fill="#FFFFFF" d="M28.003,20.585L38.96,43.902h6.509L35.046,20.585H28.003z"/>
        <filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="0.774" y="0.854" width="45.015" height="52.146">
            <feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
        </filter>
        <mask maskUnits="userSpaceOnUse" x="0.774" y="0.854" width="45.015" height="52.146" id="b">
            <path filter="url(#Adobe_OpacityMaskFilter)" id="a" fill="#FFFFFF" d="M0.774,0.854h45.015V53H0.774V0.854z"/>
        </mask>
        <path transform="translate(35.617 .646)" mask="url(#b)" fill="#FFFFFF" d="M6.39,33.765l0.004,0.008c0,0-1.973,5.692-3.004,9.479h0.022
		C2.246,47.473,1.057,51.934,0.774,53h6.593c0.872-4.244,2.537-10.136,3.155-12.276c2.49-7.873,11.865-31.97,35.267-39.87
		C45.789,0.854,19.022,1.292,6.39,33.765"/>
        <path fill="#FFFFFF" d="M213.605,26.52h0.797v-0.046l-1.324-2.394c0.316-0.112,0.592-0.316,0.792-0.585
		c0.19-0.26,0.285-0.566,0.285-0.918c0-0.552-0.171-0.973-0.513-1.262c-0.343-0.289-0.832-0.434-1.467-0.434h-1.867v5.64h0.748
		v-2.282h1.324L213.605,26.52L213.605,26.52z M211.057,21.49h1.139c0.393,0.002,0.693,0.096,0.899,0.282
		c0.21,0.187,0.312,0.454,0.312,0.803c0,0.321-0.11,0.577-0.327,0.77c-0.219,0.19-0.512,0.286-0.881,0.286h-1.143V21.49z"/>
        <path fill="none" stroke="#FFFFFF" strokeWidth="0.691" d="M212.062,28.377c2.515,0,4.554-2.039,4.554-4.554
		c0-2.515-2.039-4.554-4.554-4.554c-2.516,0-4.555,2.039-4.555,4.554C207.508,26.338,209.547,28.377,212.062,28.377z"/>
    </g>
);

let eye_swift_blue = (
    <g fill="none" fillRule="evenodd">
        <defs>
            <path id="a" d="M.774.854h45.015V53H.774z"/>
        </defs>
        <path fill="#33E800" d="M37.914 19.3c0 4.481 6.79 4.481 6.79 0 0-4.48-6.79-4.48-6.79 0M157.99 15.94c-1.635 0-3.396 1.052-3.396 3.36 0 2.31 1.761 3.362 3.396 3.362s3.396-1.052 3.396-3.362c0-2.308-1.76-3.36-3.396-3.36"/>
        <path fill="#0599FF" d="M157.991 25.282c-.981 0-1.899-.243-2.849-.706v19.246h5.696V24.576c-.949.463-1.866.705-2.847.705M0 10.461v33.223h24.871v-6.169H6.217v-7.5h17.989v-5.837H6.217v-7.642h18.654v-6.075z"/>
        <g fill="#0599FF">
            <path d="M68.048 19.574c-7.594 0-12.435 5.126-12.435 12.245 0 7.499 4.794 12.483 12.862 12.483 3.56 0 7.594-1.234 10.062-3.797l-3.702-3.655c-1.329 1.377-4.129 2.184-6.265 2.184-4.082 0-6.597-2.089-6.977-4.984h18.273c.902-9.635-3.987-14.476-11.818-14.476m6.265 9.682H61.688c.854-3.037 3.417-4.556 6.55-4.556 3.322 0 5.695 1.519 6.075 4.556M110.52 15.92c-2.517-5.127-7.88-6.598-13.053-6.598-6.123.047-12.862 2.847-12.862 9.682 0 7.452 6.265 9.255 13.052 10.063 4.414.474 7.69 1.756 7.69 4.889 0 3.606-3.703 4.982-7.643 4.982-4.034 0-7.879-1.612-9.35-5.267l-5.22 2.705c2.467 6.075 7.688 8.164 14.475 8.164 7.404 0 13.954-3.18 13.954-10.584 0-7.928-6.455-9.73-13.384-10.585-3.987-.475-7.404-1.282-7.404-4.177 0-2.468 2.23-4.414 6.882-4.414 3.607 0 6.74 1.803 7.878 3.702l4.984-2.563z"/>
        </g>
        <path fill="#0599FF" d="M129.473 20.239l-5.078 17.609-5.364-17.61h-6.455l8.211 23.542h6.74l2.421-6.93 2.088-7.83 2.088 7.83 2.421 6.93h6.74l8.163-23.541h-6.407l-5.364 17.609-5.126-17.61z"/>
        <g fill="#0599FF">
            <path d="M175.642 43.685V25.697h6.882v-5.079h-6.882v-1.566c0-2.848 1.519-4.177 3.512-4.177 1.187 0 2.326.427 3.56 1.234l2.136-4.319c-1.9-1.234-4.035-1.898-6.075-1.898-4.7 0-8.923 2.895-8.923 9.16v1.566h-4.367v5.079h4.367v17.988h5.79zM190.758 14.59v6.027h-4.367V25.6h4.367v10.11c0 5.838 3.322 8.733 8.401 8.543 1.756-.047 3.132-.332 4.794-.997l-1.614-4.936c-.854.427-1.899.712-2.8.712-1.804 0-3.038-1.09-3.038-3.322V25.6h6.502v-4.983h-6.455v-6.645l-5.79.617z"/>
        </g>
        <path fill="#0599FF" d="M27.386 20.085l10.957 23.317h6.509L34.429 20.085z"/>
        <g>
            <g transform="translate(35 .146)">
                <mask id="b" fill="#fff">
                    <use xlinkHref="#a"/>
                </mask>
                <path fill="#005f7f" d="M6.39 33.765l.004.008s-1.973 5.692-3.004 9.48h.022C2.246 47.473 1.057 51.934.774 53h6.593c.872-4.243 2.537-10.135 3.155-12.276 2.49-7.873 11.865-31.97 35.267-39.87 0 0-26.767.438-39.4 32.91" mask="url(#b)"/>
            </g>
            <path fill="#0599FF" d="M212.988 26.02h.798v-.046l-1.325-2.394a1.69 1.69 0 0 0 .792-.585c.19-.26.285-.566.285-.918 0-.552-.171-.973-.513-1.262-.342-.289-.831-.434-1.466-.434h-1.867v5.639h.748v-2.281h1.324l1.224 2.281zm-2.548-5.031h1.138c.393.003.693.097.901.283.208.187.311.454.311.803 0 .321-.109.577-.327.769-.218.191-.512.287-.881.287h-1.142v-2.142z"/>
            <path stroke="#0599FF" strokeWidth=".691" d="M211.445 27.877a4.554 4.554 0 1 0 0-9.108 4.554 4.554 0 0 0 0 9.108z"/>
        </g>
    </g>
);

let sade_logo=(
        <g transform="translate(0.000000,434.000000) scale(0.100000,-0.100000)"
           fill="#000000" stroke="none">
            <path fill="#4da6ff" d="M9395 4309 c-44 -17 -107 -41 -140 -54 -80 -32 -227 -80 -295 -96
    -73 -17 -497 -17 -598 0 -40 7 -76 11 -79 8 -19 -20 125 -199 232 -287 129
    -107 386 -217 624 -266 176 -37 310 -37 446 0 179 50 324 151 377 263 33 70
    33 189 -2 258 -69 140 -189 205 -379 205 -93 -1 -116 -4 -186 -31z"/>
            <path fill="#737373"  d="M975 3280 c-27 -5 -84 -13 -125 -19 -195 -27 -435 -144 -550 -267
    -160 -173 -216 -329 -207 -579 8 -200 28 -261 136 -408 35 -47 160 -157 179
    -157 5 0 21 -9 36 -21 33 -26 196 -97 261 -114 28 -7 82 -22 120 -33 39 -11
    144 -36 235 -56 91 -19 210 -45 265 -57 55 -12 123 -26 150 -31 78 -15 273
    -77 343 -109 35 -16 65 -29 67 -29 2 0 35 -20 72 -44 114 -75 178 -147 225
    -255 33 -75 33 -78 33 -226 0 -143 -2 -153 -29 -220 -125 -303 -445 -475 -881
    -475 -95 0 -325 23 -385 38 -145 37 -253 81 -352 142 -75 46 -219 197 -262
    273 -64 114 -106 281 -106 420 l0 67 -100 0 -100 0 0 -109 c0 -111 17 -221 45
    -287 8 -20 15 -44 15 -53 0 -22 61 -139 111 -213 74 -109 164 -189 329 -294
    62 -39 241 -102 375 -131 126 -27 139 -28 420 -28 l290 0 125 34 c108 28 272
    97 345 143 31 20 141 116 172 150 15 17 36 38 46 46 9 9 17 21 17 28 0 6 9 19
    19 28 11 10 39 61 62 114 37 85 43 110 52 214 16 172 0 329 -43 428 -65 151
    -192 283 -345 361 -33 17 -64 35 -70 40 -5 5 -16 9 -25 9 -9 0 -40 11 -69 25
    -29 14 -72 30 -94 35 -23 4 -91 22 -152 39 -60 16 -180 44 -265 61 -292 59
    -503 110 -600 145 -182 65 -328 171 -399 289 -81 135 -79 383 3 536 31 58 152
    200 170 200 4 0 22 11 39 24 91 69 311 134 514 151 196 17 501 -45 662 -135
    71 -40 74 -43 135 -94 66 -57 128 -136 173 -221 34 -65 83 -238 83 -295 0 -58
    6 -61 116 -58 l99 3 -3 65 c-4 75 -25 185 -47 236 -8 20 -15 43 -15 52 0 20
    -63 143 -106 205 -33 48 -70 92 -102 120 -8 7 -26 24 -40 38 -110 107 -373
    218 -592 249 -108 15 -410 21 -475 10z"/>
            <path fill="#737373"  d="M3704 3163 c-9 -26 -32 -84 -50 -127 -19 -44 -34 -84 -34 -89 0 -5
    -11 -31 -24 -58 -14 -27 -29 -63 -35 -81 -5 -18 -35 -94 -66 -168 -31 -74 -60
    -149 -66 -165 -5 -17 -20 -54 -34 -83 -14 -28 -25 -58 -25 -65 0 -7 -13 -40
    -29 -73 -15 -32 -31 -70 -35 -84 -9 -31 -59 -154 -97 -238 -16 -35 -29 -67
    -29 -73 0 -10 -43 -116 -96 -239 -13 -30 -30 -73 -38 -95 -8 -22 -35 -92 -61
    -155 -26 -63 -54 -133 -61 -155 -8 -22 -22 -56 -31 -75 -9 -19 -24 -55 -33
    -80 -31 -80 -81 -204 -100 -246 -11 -23 -22 -54 -26 -69 -4 -15 -20 -54 -35
    -86 -16 -33 -29 -64 -29 -70 0 -6 -16 -47 -35 -90 -19 -44 -35 -84 -35 -89 0
    -5 -13 -38 -30 -73 -16 -36 -30 -70 -30 -75 0 -5 -13 -38 -29 -73 -16 -35 -32
    -79 -36 -97 l-7 -33 112 3 112 3 26 65 c32 84 72 186 111 280 16 41 42 104 56
    140 14 36 31 79 37 95 5 17 21 54 34 82 13 29 27 65 30 80 4 16 19 55 34 88
    15 33 30 71 34 85 4 14 14 40 22 58 l15 32 744 0 c649 0 745 -2 745 -15 0 -8
    11 -38 24 -67 14 -29 34 -78 44 -108 34 -94 72 -190 97 -247 14 -29 25 -58 25
    -64 0 -6 11 -35 25 -65 14 -30 34 -83 46 -117 11 -34 24 -66 29 -72 4 -5 13
    -28 20 -50 6 -22 25 -69 40 -105 16 -36 31 -73 34 -83 5 -15 19 -17 117 -17
    110 0 111 0 106 23 -7 30 -32 98 -67 182 -56 138 -74 181 -96 240 -50 134 -74
    195 -93 236 -11 24 -29 69 -39 99 -33 93 -69 182 -96 242 -14 31 -26 61 -26
    66 0 5 -13 40 -29 78 -16 38 -43 103 -60 144 -17 41 -31 79 -31 83 0 5 -16 48
    -36 95 -66 161 -197 492 -221 557 -7 22 -21 56 -29 75 -25 57 -31 72 -49 125
    -10 28 -21 55 -25 60 -4 6 -13 28 -20 50 -7 22 -22 60 -33 85 -11 25 -31 74
    -44 110 -31 82 -60 158 -113 290 -23 58 -52 132 -65 165 -12 33 -30 78 -41
    100 l-19 40 -117 3 -116 3 -18 -48z m175 -254 c1 -9 14 -47 30 -85 16 -38 42
    -105 58 -149 78 -207 107 -285 133 -350 15 -38 34 -90 43 -115 8 -25 34 -92
    57 -150 23 -58 49 -130 59 -160 10 -30 28 -74 39 -97 12 -23 22 -49 22 -57 0
    -8 11 -41 24 -73 14 -32 43 -107 66 -168 23 -60 53 -138 66 -173 13 -34 24
    -65 24 -67 0 -3 -301 -5 -669 -5 l-669 0 17 48 c28 74 71 181 102 255 16 37
    29 72 29 77 0 5 13 39 30 74 16 36 32 77 36 91 4 15 17 48 30 75 13 26 26 61
    30 77 4 15 20 56 36 91 15 34 28 67 28 73 0 6 13 40 30 76 16 35 33 76 37 91
    3 15 19 55 35 89 15 34 28 69 28 76 0 7 14 41 30 75 17 34 30 67 30 73 0 5 15
    47 34 92 41 97 101 252 112 287 7 24 8 24 25 -15 10 -22 18 -47 18 -56z"/>
            <path fill="#737373"  d="M5330 1636 l0 -1576 548 0 c301 0 595 5 655 10 96 9 280 44 362 68
    79 24 243 105 325 160 85 58 219 173 225 194 3 9 12 19 20 22 24 9 131 174
    184 281 46 94 111 278 111 313 0 13 7 47 15 75 30 109 47 270 47 457 0 220
    -16 360 -71 605 -43 192 -175 439 -310 578 -54 57 -202 177 -217 177 -4 0 -15
    6 -23 14 -37 31 -186 100 -278 128 -207 63 -178 61 -915 65 l-678 5 0 -1576z
    m1270 1375 c281 -36 510 -140 674 -309 62 -63 166 -209 166 -233 0 -4 9 -26
    20 -48 42 -79 91 -240 118 -381 24 -134 26 -165 26 -395 0 -228 -3 -262 -27
    -389 -28 -147 -58 -242 -108 -341 -16 -33 -29 -63 -29 -67 0 -8 -75 -124 -113
    -172 -30 -41 -156 -166 -166 -166 -4 0 -18 -11 -31 -25 -26 -28 -30 -30 -175
    -105 -55 -28 -118 -55 -140 -60 -22 -4 -85 -20 -140 -35 l-100 -27 -517 -5
    -518 -6 0 1392 0 1391 453 0 c388 0 475 -3 607 -19z"/>
            <path fill="#737373"  d="M8100 1635 l0 -1575 1070 0 1070 0 0 95 0 95 -965 0 -965 0 0 680 0
    680 900 0 900 0 0 90 0 90 -900 0 -900 0 0 620 0 620 955 0 955 0 0 90 0 90
    -1060 0 -1060 0 0 -1575z"/>
        </g>
      );

let asaya_logo=(
            <g transform="translate(0.000000,102.000000) scale(0.100000,-0.100000)"
               fill="#000000" stroke="none">
                <path fill="#a8ae37" d="M2305 988 c-73 -28 -91 -31 -197 -32 -65 0 -118 -4 -118 -9 0 -4 18
        -28 41 -52 100 -108 313 -158 434 -101 60 27 85 61 85 113 0 48 -22 81 -66 99
        -49 21 -90 17 -179 -18z"/>
                <path fill="#005f7f" d="M260 761 c-66 -13 -121 -38 -159 -74 -38 -37 -70 -100 -71 -139 l0
        -28 83 0 83 0 13 36 c16 44 73 73 144 74 85 0 140 -35 140 -90 0 -61 -20 -70
        -240 -104 -57 -8 -120 -24 -142 -35 -162 -83 -142 -329 32 -387 36 -12 74 -15
        142 -12 80 3 102 8 152 34 l58 30 31 -33 c29 -31 36 -33 95 -33 105 0 109 3
        109 71 l0 58 -32 3 -33 3 -5 240 c-5 229 -6 242 -28 277 -45 72 -118 106 -246
        113 -45 2 -101 0 -126 -4z m228 -461 c-4 -78 -23 -112 -79 -145 -49 -29 -157
        -28 -196 1 -40 30 -51 66 -31 107 21 44 63 63 173 78 50 6 97 16 105 20 29 16
        32 9 28 -61z"/>
                <path fill="#005f7f" d="M1600 761 c-66 -13 -121 -38 -159 -74 -38 -37 -70 -100 -71 -139 l0
        -28 83 0 83 0 13 36 c16 44 73 73 144 74 85 0 140 -35 140 -90 0 -61 -20 -70
        -240 -104 -145 -22 -203 -56 -238 -138 -32 -78 -13 -173 47 -235 47 -48 111
        -66 223 -61 80 3 102 8 152 34 l58 30 31 -33 c29 -31 36 -33 95 -33 105 0 109
        3 109 71 l0 58 -32 3 -33 3 -5 235 c-5 213 -7 239 -26 275 -23 44 -79 87 -136
        104 -51 16 -183 22 -238 12z m228 -461 c-4 -78 -23 -112 -79 -145 -49 -29
        -157 -28 -196 1 -40 30 -51 66 -31 107 21 44 63 63 173 78 50 6 97 16 105 20
        29 16 32 9 28 -61z"/>
                <path fill="#005f7f" d="M2840 759 c-114 -19 -201 -95 -219 -191 l-8 -48 82 0 83 0 19 37 c24
        47 73 73 141 73 94 0 142 -33 142 -99 0 -47 -34 -62 -196 -87 -168 -26 -223
        -48 -262 -107 -24 -36 -27 -50 -27 -122 0 -72 3 -86 27 -122 42 -64 111 -93
        220 -93 93 0 183 23 220 56 17 16 19 16 33 -2 8 -10 15 -22 15 -25 1 -23 128
        -39 188 -23 20 6 22 13 22 65 0 59 0 59 -30 59 -19 0 -33 7 -40 19 -6 12 -10
        106 -10 235 0 127 -4 226 -11 243 -41 109 -200 163 -389 132z m225 -536 c-7
        -31 -77 -80 -125 -88 -94 -16 -180 27 -180 90 0 41 31 80 73 94 17 6 74 17
        126 25 52 9 97 18 100 22 8 8 14 -114 6 -143z"/>
                <path fill="#005f7f" d="M902 732 c-60 -22 -118 -71 -138 -119 -22 -52 -18 -130 10 -178 31
        -53 91 -85 221 -119 148 -40 188 -69 170 -123 -19 -55 -124 -81 -199 -49 -40
        17 -76 60 -76 92 0 23 -2 24 -85 24 l-85 0 6 -42 c22 -147 146 -226 336 -216
        172 9 267 89 268 225 0 63 -13 99 -48 136 -38 41 -65 52 -207 91 -70 19 -135
        42 -146 52 -69 62 54 142 155 100 28 -12 41 -25 53 -56 l16 -40 79 0 c75 0 78
        1 78 24 0 74 -53 149 -129 184 -76 35 -202 41 -279 14z"/>
                <path fill="#005f7f" d="M1960 726 c0 -3 59 -102 130 -221 l130 -216 0 -140 0 -139 85 0 85 0
        0 143 0 142 121 200 c66 110 125 208 130 218 9 16 2 17 -85 17 l-94 0 -79
        -134 -78 -134 -79 134 -79 134 -94 0 c-51 0 -93 -2 -93 -4z"/>
            </g>
)
;let asaya_logo_white=(
            <g transform="translate(0.000000,102.000000) scale(0.100000,-0.100000)"
               fill="#000000" stroke="none">
                <path fill="#ffffff" d="M2305 988 c-73 -28 -91 -31 -197 -32 -65 0 -118 -4 -118 -9 0 -4 18
        -28 41 -52 100 -108 313 -158 434 -101 60 27 85 61 85 113 0 48 -22 81 -66 99
        -49 21 -90 17 -179 -18z"/>
                <path fill="#ffffff" d="M260 761 c-66 -13 -121 -38 -159 -74 -38 -37 -70 -100 -71 -139 l0
        -28 83 0 83 0 13 36 c16 44 73 73 144 74 85 0 140 -35 140 -90 0 -61 -20 -70
        -240 -104 -57 -8 -120 -24 -142 -35 -162 -83 -142 -329 32 -387 36 -12 74 -15
        142 -12 80 3 102 8 152 34 l58 30 31 -33 c29 -31 36 -33 95 -33 105 0 109 3
        109 71 l0 58 -32 3 -33 3 -5 240 c-5 229 -6 242 -28 277 -45 72 -118 106 -246
        113 -45 2 -101 0 -126 -4z m228 -461 c-4 -78 -23 -112 -79 -145 -49 -29 -157
        -28 -196 1 -40 30 -51 66 -31 107 21 44 63 63 173 78 50 6 97 16 105 20 29 16
        32 9 28 -61z"/>
                <path fill="#ffffff" d="M1600 761 c-66 -13 -121 -38 -159 -74 -38 -37 -70 -100 -71 -139 l0
        -28 83 0 83 0 13 36 c16 44 73 73 144 74 85 0 140 -35 140 -90 0 -61 -20 -70
        -240 -104 -145 -22 -203 -56 -238 -138 -32 -78 -13 -173 47 -235 47 -48 111
        -66 223 -61 80 3 102 8 152 34 l58 30 31 -33 c29 -31 36 -33 95 -33 105 0 109
        3 109 71 l0 58 -32 3 -33 3 -5 235 c-5 213 -7 239 -26 275 -23 44 -79 87 -136
        104 -51 16 -183 22 -238 12z m228 -461 c-4 -78 -23 -112 -79 -145 -49 -29
        -157 -28 -196 1 -40 30 -51 66 -31 107 21 44 63 63 173 78 50 6 97 16 105 20
        29 16 32 9 28 -61z"/>
                <path fill="#ffffff" d="M2840 759 c-114 -19 -201 -95 -219 -191 l-8 -48 82 0 83 0 19 37 c24
        47 73 73 141 73 94 0 142 -33 142 -99 0 -47 -34 -62 -196 -87 -168 -26 -223
        -48 -262 -107 -24 -36 -27 -50 -27 -122 0 -72 3 -86 27 -122 42 -64 111 -93
        220 -93 93 0 183 23 220 56 17 16 19 16 33 -2 8 -10 15 -22 15 -25 1 -23 128
        -39 188 -23 20 6 22 13 22 65 0 59 0 59 -30 59 -19 0 -33 7 -40 19 -6 12 -10
        106 -10 235 0 127 -4 226 -11 243 -41 109 -200 163 -389 132z m225 -536 c-7
        -31 -77 -80 -125 -88 -94 -16 -180 27 -180 90 0 41 31 80 73 94 17 6 74 17
        126 25 52 9 97 18 100 22 8 8 14 -114 6 -143z"/>
                <path fill="#ffffff" d="M902 732 c-60 -22 -118 -71 -138 -119 -22 -52 -18 -130 10 -178 31
        -53 91 -85 221 -119 148 -40 188 -69 170 -123 -19 -55 -124 -81 -199 -49 -40
        17 -76 60 -76 92 0 23 -2 24 -85 24 l-85 0 6 -42 c22 -147 146 -226 336 -216
        172 9 267 89 268 225 0 63 -13 99 -48 136 -38 41 -65 52 -207 91 -70 19 -135
        42 -146 52 -69 62 54 142 155 100 28 -12 41 -25 53 -56 l16 -40 79 0 c75 0 78
        1 78 24 0 74 -53 149 -129 184 -76 35 -202 41 -279 14z"/>
                <path fill="#ffffff" d="M1960 726 c0 -3 59 -102 130 -221 l130 -216 0 -140 0 -139 85 0 85 0
        0 143 0 142 121 200 c66 110 125 208 130 218 9 16 2 17 -85 17 l-94 0 -79
        -134 -78 -134 -79 134 -79 134 -94 0 c-51 0 -93 -2 -93 -4z"/>
            </g>
);
export {
    asaya_sade,
    eye_swift_blue,
    eye_swift_white,
    sade_logo,
    asaya_logo,
    asaya_logo_white
}
